// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__hWux9","avatar":"styles_avatar__Hp4ke","alias":"styles_alias__HSzne"};